import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

export type ReturnedOfferContentInput = {
    declinedParty: String;
    reason: String;
}

export const RETURN_OFFER_MUTATION = gql`
    mutation($payload: ReturnedOfferContentInput!, $offerId: ID!){
        returnOffer(payload: $payload, id: $offerId){
            bhpnDecisionDate
            comments
            declinedDate
            declinedParty
            declinedReason
            directCareHours
            firstServiceDate
            groupCareHours
            guid
            highLevelSupervisionHours
            id
            lastServiceDate
            midLevelSupervisionHours
            offerHourPercentage
            otherClinicLocation
            provideAllEstimatedHours
            provideServiceInRequiredLanguage
            provideServicesInClinic
            status
            submittedAt
        }
    }
`;

export const useReturnOffer = (
    offerId: string,
) => {
    const [
        execute,
        {
            error,
            loading
        }
    ] = useMutation(RETURN_OFFER_MUTATION);

    const returnOffer = useCallback(async (payload: ReturnedOfferContentInput) => {
            await execute({
                variables: {
                    offerId,
                    payload,
                }
            })
    }, [execute, offerId]);


    return {
        returnOffer,
        error,
        loading
    };
};
